<template>
  <div class="fillInBox">
    <one-fill-in :id="id" :numId="numId" v-if="type != 3"></one-fill-in>
    <two-fill-in :id="id" v-else></two-fill-in>
  </div>
</template>
<script>
import oneFillIn from "@/components/insureFlow/one/index";
import twoFillIn from "@/components/insureFlow/two/index";
export default {
  name: "fillInBox",
  components: {
    oneFillIn,
    twoFillIn
  },
  data() {
    return {
      id: "",
      type: ""
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.numId = this.$route.query.numId;
  }
};
</script>
<style lang="scss"></style>
